// extracted by mini-css-extract-plugin
export default {"LoadingWrapper":"LoadingPage_LoadingWrapper__xwshf","TimeoutWrapper":"LoadingPage_TimeoutWrapper__meH-w"};